module.exports = __webpack_public_path__ + "static/media/Vertical-Box-Layou.23593013.png";